import { useRecoilValue } from "recoil";
import ocButtonGroupState from "oc/states/button-goup-state";

export const useMyTimesheetEntityButtonGroupState = (entity: string) => {
  const selectedButtonId = `MySheet${entity}EntitySelector`;
  const validity =
    useRecoilValue(ocButtonGroupState(selectedButtonId)) === 0
      ? "active"
      : "all";
  return validity;
};

export default useMyTimesheetEntityButtonGroupState;
